"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnchorPoint = exports.useAnchorPointHandle = exports.anchorContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AnchorPointHandle_1 = require("./AnchorPointHandle");
exports.anchorContext = React.createContext(null);
const useAnchorPointHandle = (spec) => {
    // Create the handle once and never recreate it, even when spec changes.
    // Recreating the handle would reset `toggle` to null and cause a position:0,0
    // flash because style() can no longer read the anchor element's bounding rect.
    // Instead, mutate spec in place so the stable handle always has the latest spec.
    // biome-ignore lint: manually manage deps
    const handle = React.useMemo(() => new AnchorPointHandle_1.AnchorPointHandle(spec), []);
    handle.spec = spec ?? {};
    React.useEffect(() => {
        const listener = () => handle.style();
        document.addEventListener('scroll', listener);
        window.addEventListener('resize', listener);
        return () => {
            document.removeEventListener('scroll', listener);
            window.removeEventListener('resize', listener);
        };
    }, [handle]);
    return handle;
};
exports.useAnchorPointHandle = useAnchorPointHandle;
const useAnchorPoint = () => React.useContext(exports.anchorContext);
exports.useAnchorPoint = useAnchorPoint;
